import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * @see {@link DismissContextMenuCommand}
 */
export type DismissContextMenuCommandProperties = CommandProperties;

/**
 * Command to dismiss/hide the context menu in the native embed experience.
 *
 * This command is used to coordinate context menu visibility between
 * Whiteboards and Databases. When one app shows a context menu, it sends
 * this command to dismiss any open context menu in the other app.
 */
export const DismissContextMenuCommand = createCommand<
  DismissContextMenuCommandProperties,
  void
>('dismiss-context-menu-command');
